import { FirebaseData } from "../General/FirebaseData";
import { TranslationData } from "../General/TranslationData";
import { DataTypeOption } from "./DataTypeData";

export class GlobalDataTypeData extends FirebaseData {
  name: TranslationData = new TranslationData();
  companyID?: string;
  options: DataTypeOption[] = [];

  setup(data: any) {
    this.name.setup(data.name, undefined);

    this.companyID = typeof data.companyID === "string" ? data.companyID : undefined;

    this.options = [];
    for (let key in data.options) {
      const translationData: TranslationData | undefined = TranslationData.getTranslationData(data.options[key].name, undefined);

      if (translationData) {
        this.options.push({
          key: key,
          name: translationData,
        });
      }
    }

    super.setup(data);
  }
}
